import React from "react";
import { usePage } from "@inertiajs/react";
import useTranslation from "@hooks/use_translation";
import TaskCard from "./TaskCard";
import type { Task } from "@/types/task";

interface TaskCardProps {
  task: Task;
  statusText: string;
}

const SetupQuickApplyProfile: React.FC<TaskCardProps> = ({ task, statusText }) => {
  const { t } = useTranslation("tasks");
  const { uploadResumeA } = usePage<{ uploadResumeA?: boolean }>().props;

  let description;
  let actionText;
  if (uploadResumeA) {
    description = t("quickApply.descriptionUploadResumeA");
    actionText = t("quickApply.completeProfileUploadResumeA");
  } else {
    description = t("quickApply.description");
    actionText = t("quickApply.completeProfile");
  }

  return (
    <TaskCard
      statusText={statusText}
      task={task}
      title={t("quickApply.title")}
      description={description}
      actionHref="/quick_apply"
      actionText={actionText}
      externalLink={false}
    />
  );
};

export default SetupQuickApplyProfile;
